import React, { useState } from 'react'
import './appointment-filter.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate, faFilter } from '@fortawesome/free-solid-svg-icons';
import { DateRange } from "react-date-range";

const STATUS_OPTIONS = [
    { value: "present", label: "Present" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "canceled", label: "Canceled" },
];

const AppointmentWaitingFilter = ({ filterStatusFun, setStatus, status, width, filterDateFun, filterDate }) => {
    const [dateRange, setDateRange] = useState([
        {
            startDate: new Date(filterDate?.startDate),
            endDate: new Date(filterDate?.endDate),
            key: "selection",
        },
    ]);

    const formatDate = (date) => {
        const inputDate = new Date(date);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const dateFilter = (ranges) => {
        setDateRange([ranges.selection]);
        const startDate = ranges.selection?.startDate || "";
        const endDate = ranges.selection?.endDate || "";
        filterDateFun('between-date', formatDate(startDate), formatDate(endDate));
    };

    const handleStatusClick = (value) => {
        if (status === value) {
            setStatus("");
            filterStatusFun("clear");
            return;
        }
        setStatus(value);
        filterStatusFun(value);
    };

    const clearStatusFilter = () => {
        setStatus("");
        filterStatusFun("clear");
    };

    return (
        <div className='filter-section' style={{ width: width }}>
            <div className='date-filter border'>
                <DateRange
                    ranges={dateRange}
                    onChange={(ranges) => dateFilter(ranges)}
                    moveRangeOnFirstSelection={false}
                    rangeColors={["#17A980"]}
                />
            </div>
            <div className="appointment-filter-status px-2 py-2 date-filter border">
                <div className="appointment-filter-status__head">
                    <div className="appointment-filter-status__head-title">
                        <span className="appointment-filter-status__icon" aria-hidden="true">
                            <FontAwesomeIcon icon={faFilter} />
                        </span>
                        <span>Status</span>
                    </div>
                    {status ? (
                        <button
                            type="button"
                            className="appointment-filter-status__clear"
                            onClick={clearStatusFilter}
                            title="Clear status filter"
                        >
                            <FontAwesomeIcon icon={faArrowsRotate} size="xs" />
                            <span>Clear</span>
                        </button>
                    ) : null}
                </div>
                <p className="appointment-filter-status__hint">
                    Select one status. Click again to show all.
                </p>
                <div
                    className="appointment-filter-status__chips"
                    role="group"
                    aria-label="Filter waiting room appointments by status"
                >
                    {STATUS_OPTIONS.map((option) => (
                        <button
                            key={option.value}
                            type="button"
                            className={`appointment-filter-status__chip appointment-filter-status__chip--${option.value}${status === option.value ? " is-active" : ""}`}
                            onClick={() => handleStatusClick(option.value)}
                            aria-pressed={status === option.value}
                        >
                            <span className="appointment-filter-status__dot" aria-hidden="true" />
                            {option.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default AppointmentWaitingFilter

